import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientService } from 'src/app/services/patient.service';
import { Kmehrhcparty } from 'src/app/models/kmehr/kmehrhcparty';
import { dmgerror, EHealthService } from 'src/app/services/e-health.service';
import { PrescriptionOutputDialogComponent } from '../../prescription/prescription-output-dialog/prescription-output-dialog.component';
import { ValidateDialogComponent } from '../../validate-dialog/validate-dialog.component';

@Component({
  selector: 'app-e-health-dmg-dialog',
  templateUrl: './e-health-dmg-dialog.component.html',
  styleUrls: ['./e-health-dmg-dialog.component.scss']
})
export class EHealthDmgDialogComponent implements OnInit {

  public dmg;
  public hcparty: Kmehrhcparty;

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<EHealthDmgDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public patient: PatientService,
              public ehealth: EHealthService) {
                this.setDmg(data.dmg);
              }

  ngOnInit(): void {
  }

  setDmg(dmg: any) {
    this.dmg = dmg;
    if (this.dmg.hcParty) {
      this.hcparty = new Kmehrhcparty();
      this.hcparty.fromJson(this.dmg.hcParty);
    }
  }

  getDmg(date: Date) {
    this.ehealth.patientdmg(this.patient.patientid, date).subscribe(result => {
      if (this.ehealth.dmg.error !== dmgerror.none) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          title: 'Erreur',
          message: this.ehealth.dmg.message,
          ok: {
            label: 'OK',
            code: 'ok'
          }
        };
        const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
      }
      this.setDmg(this.ehealth.dmg);
    });
  }
}
